module.exports = __webpack_public_path__ + "img/user.1c0efd4b.jpg";